import React from "react";

const typeImageBasePath = {
	CHALLENGE: "/api/images/challenges",
	THEORY: "/api/images/theories",
	QUIZ: "/api/images/quizzes"
};

function getEventUnitImageSourceWithSize(type, id, size) {
	const baseUrl = typeImageBasePath[(type || "unknown").toUpperCase()];
	if (!baseUrl) return undefined;
	return `${baseUrl}/${id}?size=${size}`;
}

export const getEventUnitImageSrc = (type, id) => {
	return getEventUnitImageSourceWithSize(type, id, "LARGE");
};
export const getLowQualityEventUnitImageSrc = (type, id) => {
	return getEventUnitImageSourceWithSize(type, id, "VERY_SMALL");
};

const userShowInfoCookieName = "USER_SHOW_INFO";
export const getShowInfoSetting = cookies => {
	const displayInfoString = cookies.get(userShowInfoCookieName);
	return displayInfoString === "true";
};

export const setShowInfoSetting = (cookies, displayInfo) => {
	cookies.set(userShowInfoCookieName, displayInfo, {
		path: "/",
		expires: new Date(2049, 12)
	});
};
